import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetKlaviyoListsMutation = createMutationHook(
  CreatorIntegrationsApiClient.setKlaviyoLists,
  {
    mutationKey: ['setKlaviyoLists'],
  },
)
